import { useLocalObservable } from '@euler/utils/hooks/useLocalObservable';
import { interval, map } from 'rxjs';

/** The time, re-read every `ms`: the clock and each task's elapsed time. */
export const useNow = (ms: number) =>
  useLocalObservable(
    () => interval(ms).pipe(map(() => new Date())),
    () => new Date(),
    [ms],
  );
